<script setup lang="ts">
import { useAllStores } from '@/store'

const { organizationStore, authStore, router, t } = useAllStores()

async function logout() {
  await authStore.logout()
  await router.push({ name: 'account:login' })
}
</script>

<i18n lang="yaml">
en:
  servers: Servers
  organizations: Organizations
  profile: Profile
  logout: Logout
  login: Login
  register: Register
  feedback: Feedback
ru:
  organizations: Организации
  servers: Серверы
  profile: Профиль
  logout: Выйти
  login: Вход
  register: Регистрация
  feedback: Обратная связь
</i18n>

<template>
  <nav class="navbar navbar-light navbar-expand-lg bg-light">
    <div class="container">
      <a href="/" class="navbar-brand mb-0 h1">AccessHub</a>

      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNavAltMarkup"
        aria-controls="navbarNavAltMarkup"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
        <div class="navbar-nav">
          <router-link v-if="authStore.user" :to="{ name: 'organizations:list' }" class="nav-link">
            <span>
              <img src="@/assets/organization.svg" />
            </span>
            <span class="align-middle ms-1">
              {{ organizationStore.organization.name || t('organizations') }}
            </span>
          </router-link>
          <router-link
            v-if="authStore.user && organizationStore.hasOrganization"
            :to="{ name: 'servers:list' }"
            class="nav-link"
          >
            <span>
              <img src="@/assets/server.svg" />
            </span>
            <span class="align-middle ms-1">{{ t('servers') }}</span>
          </router-link>
          <router-link
            v-if="authStore.user && organizationStore.hasOrganization"
            :to="{ name: 'feedback' }"
            class="nav-link"
          >
            <span>
              <img src="@/assets/broadcast.svg" />
            </span>
            <span class="align-middle ms-1">{{ t('feedback') }}</span>
          </router-link>

          <router-link v-if="!authStore.user" :to="{ name: 'account:login' }" class="nav-link">
            <span>
              <img src="@/assets/signin.svg" />
            </span>
            <span class="align-middle">{{ t('login') }} </span>
          </router-link>
          <router-link v-if="!authStore.user" :to="{ name: 'account:register' }" class="nav-link">
            <span class="align-middle">{{ t('register') }}</span>
          </router-link>
        </div>

        <ul class="navbar-nav ms-auto">
          <li class="nav-item dropdown dropdown-hover">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              v-if="authStore.user"
            >
              {{ authStore.user.email }}
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li>
                <router-link
                  active-class=""
                  :to="{ name: 'account:profile' }"
                  class="dropdown-item"
                  >{{ t('profile') }}</router-link
                >
              </li>
              <li>
                <hr class="dropdown-divider" />
              </li>
              <li>
                <button v-if="authStore.user" @click="logout()" class="dropdown-item" href="#">
                  {{ t('logout') }}
                </button>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<style scoped>
.dropdown:hover > .dropdown-menu {
  display: block;
}

/* Without this, clicking will make it sticky */
.dropdown > .dropdown-toggle:active {
  pointer-events: none;
}

.nav-link.active {
  font-weight: bold;
}
</style>
